export const TOOLKIT_REQUEST = 'TOOLKIT_REQUEST';
export const TOOLKIT_SUCCESS = 'TOOLKIT_SUCCESS';
export const TOOLKIT_FAIL = 'TOOLKIT_FAIL';

